export default __webpack_public_path__ + "static/media/addItem.e44cd449.svg";